'use client';
import { arrayFrom } from '../array.js';

/**
 * Возвращает новый массив уникальных значений переданного массива.
 *
 * @typeParam T - Тип массива.
 * @param array - Исходный массив.
 * @returns Массив уникальных значений исходного массива.
 *
 * @primaryExample
 * unique(['a', 'b', 'b']) // ['a', 'b']
 * unique([1, 2, null, 3, null]) // [1, 2, null, 3]
 *
 * @note Сохраняет порядок элементов в массиве.
 *
 * @stable
 * */ const unique = (array)=>{
    return arrayFrom(new Set(array));
};

export { unique };
//# sourceMappingURL=unique.js.map
